export const NEW = 'NEW';
export const IN_PROGRESS = 'IN_PROGRESS';
export const FAILED = 'FAILED';
export const SUCCESSFUL = 'SUCCESSFUL';
